import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import AccountSummaryPage, { getDefaultPageUI } from "components/pages/AccountSummaryPage";

export default function CaptureMabiAccountsExpandPending(props) {
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "paymentsWidgeteBills", "isActive"], true)
    .update([ "paymentsWidgetPending", "isActive"], true)
    .submit();

    return <AccountSummaryPage ui={ ui } />
}